<label>自訂Where條件:{{where}}</label>
<mat-dialog-content>
  <div>
    <div style="width: 100%; overflow-x: auto;">
      <table mat-table [dataSource]="whereList()">

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="width: 70px;">序號</th>
          <td mat-cell *matCellDef="let element">{{element.id}}</td>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type1">
          <th mat-header-cell *matHeaderCellDef style="width: 120px;">類型</th>
          <td mat-cell *matCellDef="let element">
            {{element.type1}}
          </td>
        </ng-container>

        <!-- Label Column -->
        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef style="width: 150px;">欄位名稱</th>
          <td mat-cell *matCellDef="let element" style="width: 150px;">
            {{element.label}}
          </td>
        </ng-container>

        <!-- DataType Column -->
        <ng-container matColumnDef="dataType">
          <th mat-header-cell *matHeaderCellDef style="width: 80px;">資料型態</th>
          <td mat-cell *matCellDef="let element" style="width: 80px;">
            {{element.dataType}}
          </td>
        </ng-container>

        <!-- Compare Column -->
        <ng-container matColumnDef="compare">
          <th mat-header-cell *matHeaderCellDef style="width: 150px;">運算</th>
          <td mat-cell *matCellDef="let element" style="width: 150px;">
            <mat-form-field appearance="outline" style="width: 150px;">
              <mat-select [(ngModel)]="element.compare">
                @for (item of compareList; track item.id) {
                <mat-option [value]="item.id">
                  {{ item.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef style="width: 150px;">運算資料</th>
          <td mat-cell *matCellDef="let element" style="width: 150px;">
            <mat-form-field appearance="outline" style="width: 150px;"
              [ngClass]="{'yellow-bg': element.type1 === '參數'}">
              <input matInput [(ngModel)]="element.value">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef style="width: 300px;">備註</th>
          <td mat-cell *matCellDef="let element">
            {{element.description}}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

  </div>
</mat-dialog-content>
